<template>
    <div class="cps-main-page">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
            <el-breadcrumb-item>交易管理</el-breadcrumb-item>
            <el-breadcrumb-item>商城订单</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>

        <div class="page-content">
            <el-row @keyup.enter.native="loadData(1)">
                <el-input v-model="queryField.orderId" size="small" placeholder="订单id"></el-input>
                <el-input v-model="queryField.orderAmount" size="small" placeholder="订单价格"></el-input>
                <el-input v-model="queryField.goodsId" size="small" placeholder="商品id"></el-input>
                <el-input v-model="queryField.goodsName" size="small" placeholder="商品名"></el-input>
                <el-input v-model="queryField.userId" size="small" placeholder="用户id"></el-input>
                <el-select v-model="queryField.goodsType" size="small" placeholder="商品类型">
                  <el-option label="商品类型" value=""/>
                  <el-option label="虚拟" value="1"/>
                  <el-option label="实物" value="2"/>
                </el-select>
                <el-select v-model="queryField.orderStatus" size="small" placeholder="订单状态">
                  <el-option label="订单状态" value=""/>
                  <el-option label="待支付" value="1"/>
                  <el-option label="待审核" value="2"/>
                  <el-option label="待发货" value="3"/>
                  <el-option label="已完成" value="4"/>
                  <el-option label="废弃" value="5"/>
                  <el-option label="发放失败" value="6"/>
                </el-select>
                <br><br>
                <el-date-picker
                    v-model="queryField.time"
                    size="small"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
                <el-button type="primary" size="small" @click="loadData(1)">查询</el-button>
                <el-button size="small" @click="reset">重置</el-button>
            </el-row>
            <el-table class="cps-table-data"
                    :data="tableData"
                    size="small"
                    border
                    v-loading="loading"
                    :height="height"
                    style="width: 100%"
                    id="rebateSetTable">
                <el-table-column
                    prop="order_id"
                    width="80"
                    label="订单id">
                </el-table-column>
                <el-table-column
                    prop="order_amount"
                    width="120"
                    label="订单价格">
                </el-table-column>
                <el-table-column
                    prop="order_status"
                    width="120"
                    :formatter="OrderStatusFormat"
                    label="订单状态">
                </el-table-column>
                <el-table-column
                    prop="goods_id"
                    width="80"
                    label="商品id">
                </el-table-column>
                <el-table-column
                    prop="goods_name"
                    width="150"
                    label="商品名">
                </el-table-column>
              <el-table-column :key="8" prop="goods_icon" label="商品图片" width="80">
                <template slot-scope="scope">
                  <el-image
                      style="width: 30px; height: 30px; border-radius: 3px"
                      :src="scope.row.goods_icon"
                      fit="cover"
                  ></el-image>
                </template>
              </el-table-column>
                <el-table-column
                    prop="goods_type"
                    width="100"
                    :formatter="GoodsTypeFormat"
                    label="商品类型">
                </el-table-column>
                <el-table-column
                    prop="user_id"
                    width="80"
                    label="下单用户id">
                </el-table-column>
                <el-table-column
                    prop="user_name"
                    width="150"
                    label="下单用户名">
                </el-table-column>
                <el-table-column
                    prop="add_time"
                    width="150"
                    label="下单时间">
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="120">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" v-if="scope.row.order_status === 2 || scope.row.order_status === 6" @click="complete(scope.row.order_id)">通过审核</el-button>
                    <el-button type="text" size="small" v-if="scope.row.order_status === 2" @click="discard(scope.row.order_id)">废弃</el-button>
                  </template>
                </el-table-column>
            </el-table>
            <!--底部分页-->
            <el-pagination class="cps-table-data"
               @current-change="loadData"
               background
               :page-size="15"
               :current-page="currentIndex"
               layout="total, prev, pager, next"
               :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>

    import { queryShopOrderList,completeShopOrder,discardShopOrder } from '@/api/request';
    export default {
        name: "shopOrder",
        data(){
          return{
              tableData:[],
              queryField:{
                orderId: '',
                orderAmount: '',
                orderStatus: '',
                goodsId: '',
                goodsName: '',
                goodsType: '',
                userId: '',
                time: [],
                start_time: '',
                end_time: '',
              },
              total: 0,
              pageSize: 15,
              height: window.innerHeight - 260,
              currentIndex: 1,
              loading: false
          }
        },
        mounted() {
          this.loadData(1)
        },
        methods:{
            loadData(index){
                this.loading = true;
                if (this.queryField.time != null && this.queryField.time.length > 0) {
                  this.queryField.start_time = this.queryField.time[0] + " 00:00:00";
                  this.queryField.end_time = this.queryField.time[1] + " 23:59:59";
                } else {
                  this.queryField.start_time = "";
                  this.queryField.end_time = "";
                }
                let params = {
                    pageNo: index,
                    pageSize: this.pageSize,
                    params: this.queryField
                }

                queryShopOrderList(params).then( res => {
                    this.tableData = res.data.list;
                    this.total = res.data.total;
                    this.currentIndex = index;
                    this.loading = false;
                })
            },
            reset(){
              this.queryField = {
                orderId: '',
                orderAmount: '',
                orderStatus: '',
                goodsId: '',
                goodsName: '',
                goodsType: '',
              }
              this.loadData(1);
            },
            complete(orderId){
              this.$confirm('确认通过审核吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                completeShopOrder(orderId).then(res => {
                  if (res.data.success) {
                    this.$message.success("操作成功")
                    this.loadData(1);
                  } else {
                    this.$message.error(res.data.error.message);
                  }
                });
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                })
              })
            },
            discard(orderId){
                this.$confirm('确认废弃订单吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    discardShopOrder(orderId).then( res => {
                        if (res.data.success) {
                            this.$message.success("操作成功")
                            this.loadData(1);
                        } else {
                            this.$message.error(res.data.error.message);
                        }
                    })
                }).catch(() => {
                    this.$message({
                      type: 'info',
                      message: '已取消'
                    })
                })
            },
            OrderStatusFormat(row, column, cellValue){  //1:待支付,2:待审核，3：已发货，4：已完成
              let str = '';
              if (cellValue == 1){
                str = '待支付';
              }else if(cellValue == 2){
                str = '待审核';
              }else if(cellValue == 3){
                str = '待发货';
              }else if(cellValue == 4){
                str = '已完成';
              }else if(cellValue == 5){
                str = '废弃'
              }else if(cellValue == 6){
                  str = '发放失败'
              }
              return str;
            },
            GoodsTypeFormat(row, column, cellValue){  //1:虚拟,2:实物
              let str = '';
              if (cellValue == 1){
                str = '虚拟';
              }else if(cellValue == 2){
                str = '实物';
              }
              return str;
            }
        }
    }
</script>

<style lang="scss" scoped>
/deep/ .is-active {
  background-color: unset !important;
}
</style>